import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface Usuario {
  usuarioUuid: string;
  nome: string;
  telefone: string;
  plano: string | null;
  ativo: boolean;
  ativadoEm?: string | null;
  inativadoEm?: string | null;
  validoAte?: string | null;
}

export interface ContatoEmergenciaRequest {
  usarDadosParceiro: boolean;
  nome: string | null;
  telefone: string | null;
  email: string | null;
}

export interface UsuarioParceiroRequest {
  nome: string;
  telefone: string;
  email: string | null;
  dataNascimento: string | null;
  possuiLimitacaoFisica: boolean | null;
  informacaoMobilidade: string | null;
  emergencia: ContatoEmergenciaRequest;
}

export interface UsuarioParceiroDetalhe {
  usuarioUuid: string;
  nome: string;
  telefone: string;
  email: string | null;
  dataNascimento: string | null;
  plano: string | null;
  ativo: boolean;
  possuiLimitacaoFisica: boolean;
  informacaoMobilidade: string | null;
  emergencia: {
    usarDadosParceiro: boolean;
    nome: string | null;
    telefone: string | null;
    email: string | null;
  };
}

@Injectable({ providedIn: 'root' })
export class UsuariosService {
  private http = inject(HttpClient);

  // Se environment.apiUrl já contém /api,
  // use apenas /parceiro/usuarios.
  private url = `${environment.apiUrl}/parceiro/usuarios`;

  listar() {
    return this.http.get<Usuario[]>(this.url);
  }

  criar(dados: UsuarioParceiroRequest) {
    return this.http.post<UsuarioParceiroDetalhe>(this.url, dados);
  }

  atualizar(uuid: string, dados: UsuarioParceiroRequest) {
    return this.http.put<UsuarioParceiroDetalhe>(`${this.url}/${uuid}`, dados);
  }

  buscarDetalhe(uuid: string) {
    return this.http.get<UsuarioParceiroDetalhe>(`${this.url}/${uuid}`);
  }

  inativar(uuid: string) {
    return this.http.patch<void>(`${this.url}/${uuid}/inativar`, {});
  }

  reativar(uuid: string) {
    return this.http.patch<void>(`${this.url}/${uuid}/reativar`, {});
  }
}
